import React from 'react';
import {
  Box, Typography, Button, TextField, IconButton, List,
  MenuItem, FormControl, InputLabel, Select, Divider, Chip,
  Tabs, Tab, Switch, Slider, ToggleButton, ToggleButtonGroup,
  CircularProgress, FormControlLabel, Checkbox, Dialog,
  DialogTitle, DialogContent, DialogActions, Paper,
  Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import {
  Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon,
  CallSplit as CallSplitIcon, Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon, Check as CheckMarkIcon,
  Clear as CloseMarkIcon, Image as ImageIcon, TextFields as TextIcon,
  Title as TitleIcon, VideoLibrary as VideoIcon,
  SmartButton as ButtonIcon, CloudUpload as UploadIcon,
  FormatListBulleted as ListIcon, Star as StarIcon,
  Info as InfoIcon, Warning as WarningIcon, Verified as VerifiedIcon,
  ShoppingCart as ShoppingCartIcon, FileCopy as DuplicateIcon,
  ExpandMore as ExpandMoreIcon, ViewModule as TemplateIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { getPreset, getPresetFontFamilies } from '../../../../textStyle.js';
import { getSuggestedTextColors } from '../../../../utils/offerColorUtils';
import { ELEMENT_TYPES, TEMPLATE_TYPE_OPTIONS } from '../../../../utils/offerElementTypes';
import { LAYOUT_CONFIGS } from '../../../../utils/offerLayoutConfigs';
import { LAYOUT_TYPES } from '../../../../utils/offerElementTypes';
import S3FileUpload from '../../../S3FileUpload';
import SimplePresetSelector from '../../../SimplePresetSelector';
import ButtonPresetSelector from '../../../ButtonPresetSelector';
import ComparisonTablePresetSelector from '../../../ComparisonTablePresetSelector';
import {
  BRANDS_EDITOR_RIGHT_PANEL_WIDTH, BRANDS_EDITOR_SAVED_COL_WIDTH,
  BRANDS_PAGE_MAX_HEIGHT, BRANDS_REF_DEVICE_WIDTH, BRANDS_REF_DEVICE_HEIGHT,
  SETUPS_REF_DEVICE_WIDTH, SETUPS_REF_DEVICE_HEIGHT,
} from '../../../../utils/offerDeviceConstants';
import { useOfferBuilder } from '../../OfferBuilderContext';

const SavedElementsColumn = () => {
  const {
      isMobile, isBrandsPage, templatesOnly, customElementsOnly,
      paginationEnabled, isEditingMode, forceRender,
      selectedElement, selectedElementContext, selectedSubElement,
      setSelectedElement, setSelectedElementContext, setSelectedSubElement,
      tabValue, setTabValue, rightPanelOpen, setRightPanelOpen,
      elements, pages, currentPageIndex, pageSettings,
      updateElement, addElement, moveToNewPage,
      handleImageUpload, handleThumbnailUpload, handleMediaUploadForElement,
      contentTabTempValue, setContentTabTempValue,
      buttonContentTabTempValue, setButtonContentTabTempValue,
      buttonUrlTabTempValue, setButtonUrlTabTempValue,
      saveContentTabEdit, cancelContentTabEdit, handleContentTabKeyPress,
      saveButtonContentTabEdit, cancelButtonContentTabEdit, handleButtonContentTabKeyPress,
      saveButtonUrlTabEdit, cancelButtonUrlTabEdit, handleButtonUrlTabKeyPress,
      listItemTextValues, setListItemTextValues,
      localRatingText, setLocalRatingText,
      renameElementId, setRenameElementId, renameElementValue, setRenameElementValue,
      getCurrentFontFamily, getInlineBackgroundColors, getInlineTextColors,
      savedOfferElements, filteredSavedElements, setFilteredSavedElements,
      loadSavedOfferElements, loadSavedElement, deleteSavedElement, editSavedElement,
      selectedBrand, selectedOffer, brands, offers, setSelectedBrand, setSelectedOffer, loadOffersForBrand,
      setShowStatusAlert, setStatusMessage, setStatusTitle,
      showConfirmDialog, setShowConfirmDialog, confirmDialogTitle, confirmDialogMessage,
      confirmAction, setConfirmAction, setConfirmDialogTitle, setConfirmDialogMessage,
      showRenameDialog, setShowRenameDialog,
      showLayoutSelector, setShowLayoutSelector, targetZone, setTargetZone,
      showSaveElementDialog, setShowSaveElementDialog, isUpdatingElement, setIsUpdatingElement,
      currentElementName, setCurrentElementName, selectedSavedElementId, setSelectedSavedElementId,
      setSaveType, saveType, saveCurrentElement,
      showLoadTemplateAlert, setShowLoadTemplateAlert, loadTemplateError,
      showReplaceConfirm, setShowReplaceConfirm, pendingTemplateData, loadReplaceTemplate,
      showStatusAlert, statusMessage, statusTitle,
      showPromptDialog, setShowPromptDialog, promptDialogTitle, promptDialogMessage,
      promptDialogValue, setPromptDialogValue, promptAction, setPromptAction,
      showSaveDialog, setShowSaveDialog, saveTemplate,
      showTemplatesList, setShowTemplatesList, templates, loadTemplate, deleteTemplate,
      setOffers, setForceRender,
      imageUploading, uploadingElementId, savedTemplates, setSavedTemplates,
      preBuiltTemplates, loadPreBuiltTemplate, currentTemplateId, setCurrentTemplateId,
      templateName, setTemplateName, templateType, setTemplateType,
      templateSubtype, setTemplateSubtype, groupTemplatesByType, addLayout,
      showBrandOfferAlert, setShowBrandOfferAlert, renameSavedElement,
      setCurrentPageIndex, setElements, setNextPageId, setPageSettings,
      setPages, setPaginationEnabled, setPendingTemplateData,
    } = useOfferBuilder();

  return (
    <Box sx={{
      width: BRANDS_EDITOR_SAVED_COL_WIDTH,
      flexShrink: 0,
      minWidth: 0,
      borderLeft: '1px solid #e0e0e0',
      backgroundColor: '#f9f9f9',
      overflowY: 'auto',
      p: 1,
      pb: 10,
      height: 'calc(100vh - 50px)'
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{
          fontWeight: 700,
          color: 'primary.main',
          fontSize: '0.8rem'
        }}>
          Saved Items
        </Typography>
        {/* {(selectedBrand || selectedOffer) && (
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setSelectedBrand('');
              setSelectedOffer('');
              setOffers([]);
            }}
            sx={{ fontSize: '0.7rem' }}
          >
            Clear Filter
          </Button>
        )} */}
      </Box>
    
      {(() => {
        console.log('🎨 Rendering saved elements display:', {
          filteredCount: filteredSavedElements.length,
          totalCount: savedOfferElements.length,
          selectedBrand,
          selectedOffer,
          filteredElements: filteredSavedElements.map(el => ({ id: el._id, name: el.name, brandId: el.brandId, offerId: el.offerId })),
          actualElementsBeingRendered: filteredSavedElements.length,
          forceRender
        });
        console.log('🎨 filteredSavedElements state:', filteredSavedElements);
        console.log('🎨 About to render:', filteredSavedElements.length === 0 ? 'EMPTY STATE' : `${filteredSavedElements.length} ELEMENTS`);
        console.log('🎨 DEBUG: What items are being rendered:', filteredSavedElements.map(el => `${el.name} (${el.brandId}/${el.offerId})`));
        console.log('🎨 DEBUG: Current selectedBrand:', selectedBrand, 'selectedOffer:', selectedOffer);
        console.log('🎨 DEBUG: State update timestamp:', Date.now());
        console.log('🎨 DEBUG: Force render count:', forceRender);
        return filteredSavedElements.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {savedOfferElements.length === 0 ? 'No saved items yet' : 'No items match the selected brand/offer'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {savedOfferElements.length === 0
                ? 'Save individual elements or entire templates for reuse'
                : 'Try selecting a different brand or offer, or clear the selection'
              }
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1.5 }}>
            {filteredSavedElements.map((element) => (
              <Box
                key={element._id}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  p: 0.5,
                  overflow: 'hidden'
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  fullWidth
                  onClick={() => loadSavedElement(element)}
                  color={element.type === 'template' && element.properties?.isTemplate ? 'primary' : 'inherit'}
                  sx={{
                    py: 0.25,
                    px: 0.5,
                    minWidth: 0,
                    textTransform: 'none',
                    justifyContent: 'flex-start',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    lineHeight: 1.2,
                    textAlign: 'left',
                    display: 'block',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word'
                  }}
                >
                  {element.name}
                </Button>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 0.25,
                  mt: 0.25,
                  pt: 0.25,
                  borderTop: '1px solid rgba(0,0,0,0.05)'
                }}>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setRenameElementId(element._id);
                      setRenameElementValue(element.name);
                      setShowRenameDialog(true);
                    }}
                    sx={{
                      padding: '2px',
                      color: 'primary.main',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                        color: 'primary.contrastText'
                      }
                    }}
                    title="Rename"
                  >
                    <EditIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setConfirmDialogTitle('Delete Saved Item');
                      setConfirmDialogMessage(`Are you sure you want to delete "${element.name}"?`);
                      setConfirmAction(() => () => {
                        deleteSavedElement(element._id);
                      });
                      setShowConfirmDialog(true);
                    }}
                    sx={{
                      padding: '2px',
                      color: 'error.main',
                      '&:hover': {
                        backgroundColor: 'error.light',
                        color: 'error.contrastText'
                      }
                    }}
                    title="Delete"
                  >
                    <DeleteIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                </Box>
              </Box>
            ))}
          </Box>
        );
      })()}
    </Box>
  );
};

export default SavedElementsColumn;
